<template>
  <!-- One iconoir icon, drawn from a trusted generated map (scripts/generateIconoirMap.mjs).
       The markup comes from the map, never from section data. Unknown name: the fallback slot. -->
  <svg v-if="inner" class="s2-glyph" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="1.5" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" v-html="inner"></svg>
  <slot v-else></slot>
</template>

<script setup>
import {computed} from "vue";

// `map` is one first-letter shard of the icon set, loaded by IconoirIcon.
const props = defineProps({name: {type: String, default: ""}, map: {type: Object, default: () => ({})}});
const inner = computed(() => (Object.hasOwn(props.map, props.name) ? props.map[props.name] : ""));
</script>

<style>
.s2-glyph { width: 1.25em; height: 1.25em; flex: none; display: block; }
</style>
